import api from "./api";

export const fetcher = (url) =>
  api.get(url).then((res) => res.data.data);

  export const variantFetcher = (url) =>
  api.get(url).then((res) => res.data);
